import apiRequest from './apiRequest';

// Define sentiment enum values
export enum BrowseFeedbackSentiment {
  // sentiment for v1
  EXCEPTIONAL = 'EXCEPTIONAL',
  NEUTRAL = 'NEUTRAL',
  BAD_FEET = 'BAD_FEET',
  BAD_MOTION = 'BAD_MOTION',
  POOR_LABELS = 'POOR_LABELS',

  // sentiment for v2
  ADD_TO_FEATURED = 'ADD_TO_FEATURED',
  HEARTS = 'HEARTS',
  UPVOTES = 'UPVOTES',
  DOWNVOTES = 'DOWNVOTES',
  FLAGGED = 'FLAGGED',
  REMOVE_FROM_SUBCATEGORY = 'REMOVE_FROM_SUBCATEGORY',

  // sentiment for foot contact data
  FOOT_CONTACT = 'FOOT_CONTACT',
}

// Define the request type
export type BrowseFeedbackRequest = {
  category?: string;
  jobID: string;
  sentiment: BrowseFeedbackSentiment;
  subcategory?: string;
  reason?: string; // Optional reason, primarily for POOR_LABELS
};

// Define the response type
type Response = {
  jobID: string;
  sentiment: BrowseFeedbackSentiment;
  reason?: string;
  createdAt: string;
  userID: string;
  PK: string;
  SK: string;
};

/**
 * Submit feedback for a browse motion
 * @param params The feedback parameters
 * @returns API response
 */
export default async function postBrowseFeedback({
  category,
  jobID,
  sentiment,
  subcategory,
  reason,
}: BrowseFeedbackRequest) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/jobs/browse/${jobID}/feedback`,
    {
      method: 'POST',
      body: JSON.stringify({
        category,
        subcategory,
        sentiment,
        reason,
      }),
    },
  );
}
